import { Button, Descriptions, Result, Space, Spin, Tag } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import API from 'helpers/API';
import { HeadingH1 } from 'components/ui';
import { getReclaimStatus } from 'utils/CodeMapper';
import { getApiErrorMessage } from 'utils/getApiErrorMessage';
import { getDisplayName } from 'utils/getDisplayName';

const Page = () => {
  const { rid } = useParams();
  const navigate = useNavigate();
  const [reclaim, setReclaim] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState();

  useEffect(() => {
    let isMounted = true;

    const fetchReclaim = async () => {
      setIsLoading(true);
      setFetchError(undefined);

      const response = await API.get(`/customer/reclaims/${rid}`);

      if (!isMounted) return;

      if (response?.success) {
        setReclaim(response.data);
      } else {
        setReclaim(undefined);
        setFetchError(getApiErrorMessage(response, '회수 상세 정보를 불러오지 못했습니다.'));
      }

      setIsLoading(false);
    };

    fetchReclaim();

    return () => {
      isMounted = false;
    };
  }, [rid]);

  if (isLoading) {
    return (
      <Space direction="vertical" align="center" size={16} style={{ width: '100%', padding: '80px 0' }}>
        <Spin size="large" />
      </Space>
    );
  }

  if (fetchError || !reclaim) {
    return (
      <Result
        status="error"
        title="회수 상세 정보를 불러오지 못했습니다."
        subTitle={fetchError}
        extra={[
          <Button key="back" onClick={() => navigate(-1)}>
            뒤로
          </Button>,
        ]}
      />
    );
  }

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <HeadingH1 title={'회수상세'} />
      <Descriptions bordered column={2}>
        <Descriptions.Item label="상태">
          <Tag>{getReclaimStatus(reclaim.status)}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="수량">{reclaim.quantity}</Descriptions.Item>
        <Descriptions.Item label="회수 요청일">
          {reclaim.reclaimDate
            ? `${reclaim.reclaimDate.slice(0, 4)}-${reclaim.reclaimDate.slice(4, 6)}-${reclaim.reclaimDate.slice(6, 8)}`
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="회사명">{reclaim.customerCompany}</Descriptions.Item>
        <Descriptions.Item label="고객명">{reclaim.customerName}</Descriptions.Item>
        <Descriptions.Item label="전화번호">{reclaim.customerPhone}</Descriptions.Item>
        <Descriptions.Item label="최종 거점">{reclaim.reclaimLocation?.name}</Descriptions.Item>
        <Descriptions.Item label="주소" span={2}>
          {reclaim.customerAddress} {reclaim.customerAddressDetail}
        </Descriptions.Item>
        <Descriptions.Item label="메모" span={2}>
          {reclaim.memo || '-'}
        </Descriptions.Item>
        <Descriptions.Item label="등록자">{getDisplayName(reclaim.createdBy)}</Descriptions.Item>
        <Descriptions.Item label="등록일시">
          {dayjs(reclaim.createdAt).format('YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
        <Descriptions.Item label="수정자">{getDisplayName(reclaim.updatedBy)}</Descriptions.Item>
        <Descriptions.Item label="수정일시">
          {dayjs(reclaim.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
      </Descriptions>
      <Button onClick={() => navigate(-1)}>뒤로</Button>
    </Space>
  );
};

export default Page;
